import { GlobalResponseObject } from  "../../../common";
import { LineOperationCompletionModel } from "./line-operation-completion.model";


export class OperationCompletionResponse extends GlobalResponseObject {
    data?:LineOperationCompletionModel[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?:LineOperationCompletionModel[]){
        super(status,intlCode,internalMessage)
        this.data = data;
    }
}